import { Navigate } from "react-router-dom";
import { useAppSelector } from "../hooks/usereduxHooks";

export default function PublicRoute({ children }: { children: any }) {
  const { user } = useAppSelector((store) => store.User);
  return user?.jwtToken ? <Navigate to="/" replace /> : children;
}
